const Styles = {
  searchContainer: {
    mt: 3,
    mb: 3,
  },
  searchView: {
    display: 'flex',
    flexWrap: 'wrap',
    mt: 5,
    px: 6,
  },
  inputView: {
    width: 300,
  },
  searchBtnView: {
    display: 'flex',
    flexDirection: 'row',
    px: 5,
    mb: 3,
    mt: 0,
    justifyContent: 'right',
  },
  addIcon: {
    fontSize: 'small',
    mr: 0.5,
  },
  resetBtn: {
    mr: 2,
  },
  addInputView: {
    mb: 2,
  },
  submitBtn: {
    mb: 4,
    mt: 1,
  },
  modalStyle: {
    marginTop: 50,
  },
  modalBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    px: 4,
    pt: 3,
  },
  editBtn: {
    mr: 2,
  },
  menuBoxShadow: {
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
  },
};

export default Styles;
